import { PathParam } from '@remix-run/router/dist/utils';
import { generatePath as _generatePath } from 'react-router-dom';

export const generatePath = <Path extends string>(
  originalPath: Path,
  params?: {
    [key in PathParam<Path>]?: string | null | undefined;
  }
): string => {
  return _generatePath(originalPath, params as any);
};
